<template>
  <div class="modal fade" @keyup.esc.prevent="closeModal(false)" tabindex="-1" id="notificationScheduleModal" aria-labelledby="notificationScheduleModalLabel">
    <div class="modal-dialog modal-lg">
      <div v-if="loaded" class="modal-content shadow-none">
        <loader />
      </div>
      <div v-else class="modal-content shadow-none">
        <div class="modal-header p-5">
          <h5 class="modal-title">{{ schedule.id ? 'Запланированное уведомление' : 'Новое уведомление' }}</h5>
          <div @click="closeModal(false)" class="btn btn-icon btn-sm btn-active-light-primary ms-2">
            <i class="ki-duotone ki-cross fs-2x"><span class="path1"></span><span class="path2"></span></i>
          </div>
        </div>
        <div class="modal-body p-5">
          <div class="row">
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="schedule.type" class="required">Type</label>
                <v-select
                  v-model="schedule.type"
                  input-id="schedule.type"
                  :options="typeOptions"
                  :reduce="(item) => item.code"
                  label="label"
                  placeholder="Выберите..."
                  class="mb-3 bg-gray-100 form rounded"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="schedule.template" class="required">Шаблон (код)</label>
                <v-select
                  v-model="schedule.template"
                  input-id="schedule.template"
                  :loading="templatesLoading"
                  :disabled="templatesLoading"
                  :options="templateSelectOptions"
                  :reduce="(item) => item.code"
                  placeholder="Выберите шаблон..."
                  class="mb-3 bg-gray-100 form rounded"
                  label="label"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <input-field v-model="schedule.userId" id="schedule.userId" name="schedule.userId" placeholder="User ID" type="text" mb="5" :disabled="isTopicFilled" />
            </div>
            <div class="col-md-6">
              <div class="custom-select dynamic mb-5">
                <label for="schedule.topic">Topic</label>
                <v-select
                  v-model="schedule.topic"
                  input-id="schedule.topic"
                  :loading="topicsLoading"
                  :disabled="isUserIdFilled || topicsLoading"
                  :options="topicSelectOptions"
                  :reduce="(item) => item.code"
                  placeholder="Выберите топик..."
                  class="mb-3 bg-gray-100 form rounded"
                  label="label"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input-field v-model="schedule.priority" id="schedule.priority" name="schedule.priority" placeholder="Priority" type="number" mb="5" />
            </div>
            <div class="col-md-4">
              <div class="form-floating mb-5">
                <input
                  id="schedule.planSentAt"
                  v-model="planSentAtInput"
                  class="form-control form-control-solid"
                  type="datetime-local"
                  autocomplete="off"
                >
                <label for="schedule.planSentAt">Дата и время отправки (локальное → мс)</label>
              </div>
            </div>
            <div class="col-md-4">
              <input-field
                v-model="schedule.notificationId"
                id="schedule.notificationId"
                name="schedule.notificationId"
                placeholder="Notification ID (необязательно)"
                type="text"
                mb="5"
              />
            </div>
          </div>

          <div class="mb-3">
            <div class="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2 border-top border-bottom py-2">
              <div class="fs-6 fw-bold">
                Params
              </div>
              <button type="button" class="btn btn-sm btn-light-primary" @click="addParamRow">
                <i class="ki-outline ki-plus fs-5"></i> Добавить
              </button>
            </div>
            <div v-for="(row, index) in paramsRows" :key="'param-' + index" class="row align-items-center pb-2 border-bottom mb-3">
              <div class="col-md-4">
                <input-field
                  v-model="row.key"
                  :id="'params.' + index + '.key'"
                  :name="'params.' + index + '.key'"
                  placeholder="Ключ"
                  type="text"
                  mb="0"
                />
              </div>
              <div class="col">
                <input-field
                  v-model="row.value"
                  :id="'params.' + index + '.value'"
                  :name="'params.' + index + '.value'"
                  placeholder="Значение"
                  type="text"
                  mb="0"
                />
              </div>
              <div class="col-auto">
                <button type="button" class="btn btn-icon btn-sm btn-light-danger w-50px h-50px" @click="removeParamRow(index)" title="Удалить">
                  <i class="ki-outline ki-trash fs-5"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer p-5 justify-content-between">
          <button type="button" @click="closeModal(false)" class="btn btn-light btn-sm">Закрыть</button>
          <button type="button" @click="saveSchedule" :disabled="saving" class="btn btn-primary btn-sm">
            {{ saving ? 'Сохранение...' : 'Сохранить' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/Loader'
import InputField from '@/components/Fields/InputField'
import vSelect from 'vue-select'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const DEFAULT_TOPIC = ''

const TYPE_OPTIONS = [
  { code: 'SMS', label: 'SMS' },
  { code: 'PUSH', label: 'Отправка с сохранением в Историю' },
  { code: 'PUSH_ONLY', label: 'Отправка без сохранения в Историю' },
  { code: 'PULL_ONLY', label: 'Запись в Историю без отправки' },
]

const createDefaultSchedule = () => ({
  id: null,
  notificationId: '',
  type: 'PUSH',
  template: '',
  userId: '',
  topic: DEFAULT_TOPIC,
  params: {},
  priority: 0,
})

export default {
  name: 'NotificationScheduleModal',
  components: { Loader, InputField, vSelect },
  props: {
    itemData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loaded: false,
      saving: false,
      schedule: createDefaultSchedule(),
      paramsRows: [],
      planSentAtInput: '',
      templates: [],
      templatesLoading: false,
      topics: [],
      topicsLoading: false,
      typeOptions: TYPE_OPTIONS,
    };
  },
  computed: {
    templateSelectOptions() {
      return this.templates.map((t) => ({
        code: t.code,
        label: t.code || '',
      })).filter((o) => o.code);
    },
    topicSelectOptions() {
      return this.topics
        .filter((t) => t && t.fcmTopic)
        .map((t) => ({
          code: t.fcmTopic,
          label: `${t.name?.['ru-RU'] || t.code || ''} (${t.fcmTopic})`,
        }));
    },
    isUserIdFilled() {
      return !!(this.schedule.userId && String(this.schedule.userId).trim());
    },
    isTopicFilled() {
      return !!(this.schedule.topic && String(this.schedule.topic).trim());
    },
  },
  mounted() {
    this.hydrateSchedule();
    this.fetchTemplates();
    this.fetchTopics();
    setTimeout(() => {
      const modalEl = document.getElementById('notificationScheduleModal');
      if (modalEl) {
        modalEl.addEventListener('mousedown', (event) => {
          if (event.target.classList.contains('modal')) this.closeModal(false);
        });
      }
    }, 10);
  },
  methods: {
    fetchTopics() {
      this.topicsLoading = true;
      axios
        .get('/notification/api/v2/issuer/topics', {
          params: { page: 0, size: 500 },
        })
        .then((res) => {
          const payload = res?.data;
          this.topics = Array.isArray(payload?.content) ? payload.content : [];
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
          this.topics = [];
        })
        .finally(() => {
          this.topicsLoading = false;
        });
    },
    fetchTemplates() {
      this.templatesLoading = true;
      axios
        .get('/notification/api/v2/issuer/template', {
          params: { page: 0, size: 500 },
        })
        .then((res) => {
          const payload = res?.data;
          const content = Array.isArray(payload?.content) ? payload.content : [];
          this.templates = content;
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
          this.templates = [];
        })
        .finally(() => {
          this.templatesLoading = false;
        });
    },
    msToDatetimeLocal(ms) {
      if (ms == null || ms === '') return '';
      const raw = typeof ms === 'string' ? ms.trim() : ms;
      const parsedValue = typeof raw === 'string' && raw !== '' && Number.isNaN(Number(raw))
        ? raw
        : Number(raw);
      const d = new Date(parsedValue);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },
    hydrateSchedule() {
      const source = this.itemData || {};
      const templateCode = typeof source.template === 'object' && source.template !== null
        ? (source.template.code || '')
        : (source.template || '');
      this.schedule = {
        ...createDefaultSchedule(),
        ...source,
        template: templateCode,
      };
      this.schedule.type = source.type || 'PUSH';
      this.hydrateParamsFromSource(source.params);
      const incomingPlanSentAt = source.planSentAt ?? source.scheduleAt ?? '';
      this.planSentAtInput = this.msToDatetimeLocal(incomingPlanSentAt);
    },
    hydrateParamsFromSource(params) {
      const p = params && typeof params === 'object' ? params : {};
      const keys = Object.keys(p);
      if (!keys.length) {
        this.paramsRows = [];
        return;
      }
      this.paramsRows = keys.map((key) => ({
        key,
        value: p[key] != null ? String(p[key]) : '',
      }));
    },
    addParamRow() {
      this.paramsRows.push({ key: '', value: '' });
    },
    removeParamRow(index) {
      this.paramsRows.splice(index, 1);
    },
    buildParamsObject() {
      if (!this.paramsRows.length) return {};
      const acc = {};
      this.paramsRows.forEach((row) => {
        const key = row.key != null ? String(row.key).trim() : '';
        if (!key) return;
        acc[key] = row.value != null ? String(row.value).trim() : '';
      });
      return acc;
    },
    planSentAtToMs() {
      if (!this.planSentAtInput || String(this.planSentAtInput).trim() === '') return 0;
      const t = new Date(this.planSentAtInput).getTime();
      return Number.isNaN(t) ? 0 : t;
    },
    closeModal(isUpdate) {
      const modalInstance = bootstrap.Modal.getInstance(document.getElementById('notificationScheduleModal'));
      if (modalInstance) modalInstance.hide();
      this.$emit('closeModal', isUpdate);
    },
    saveSchedule() {
      const userId = this.schedule.userId != null ? String(this.schedule.userId).trim() : '';
      const topic = this.schedule.topic != null ? String(this.schedule.topic).trim() : '';
      if (!userId && !topic) {
        notify({
          duration: 7000,
          type: 'error',
          speed: 1000,
          title: 'Ошибка',
          text: 'Нужно заполнить либо User ID, либо Topic',
        });
        return;
      }

      this.saving = true;
      const templateCode = typeof this.schedule.template === 'object' && this.schedule.template !== null
        ? (this.schedule.template.code || null)
        : (this.schedule.template || null);
      const payload = {
        type: this.schedule.type || null,
        template: templateCode,
        userId: userId || null,
        topic: topic || null,
        params: this.buildParamsObject(),
        priority: Number(this.schedule.priority || 0),
        planSentAt: this.planSentAtToMs(),
      };
      if (userId) {
        payload.topic = null;
      } else {
        payload.userId = null;
      }
      const nid = this.schedule.notificationId != null ? String(this.schedule.notificationId).trim() : '';
      if (nid) {
        payload.notificationId = nid;
      }
      if (this.schedule.id) {
        payload.id = this.schedule.id;
      }

      axios.post('/notification/api/v2/issuer/schedules', payload)
        .then(() => {
          notify({
            duration: 7000,
            type: 'success',
            speed: 1000,
            title: 'Успешно',
            text: 'Запланированное уведомление сохранено',
          });
          this.closeModal(true);
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: err?.response?.data?.errorDescription ?? err.message,
          });
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style scoped>

</style>
